export const SET_SELECTED_CLIENT = "SET_SELECTED_CLIENT";

export const setSelectedClient = payload => ({
  type: SET_SELECTED_CLIENT,
  payload
});
